import type { MediaPayload } from "../annotations/WhatsAppAnnotations";
import { uploadFile } from "../services/FileUploadService";

export const uploadMediaFiles = async (
  media: MediaPayload[],
  personId: number | null,
  path:string
) => {
  try {
    const response = await uploadFile({
      fileData: media,
      path,
      microserviceURL: process.env.REACT_APP_WEBCONNECTOR_BACKEND_URL ?? "",
      personId,
    });

    return response.map((file: any) => ({
      mediaFile: null,
      mediaName: file.custom_name,
      mediaPath: file.path,
      mediaId: file.id,
      mediaCaption: file.caption,
      mediaType: file.type,
      mediaSize: file.size
    }));
  } catch (error) {
    console.error("Upload failed:", error);
    throw error;
  }
};
